/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ShivaWebPublicConfiguration } from '../shiva-web-public-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { getStationCurrentOccupancy } from '../fn/occupancy/get-station-current-occupancy';
import { GetStationCurrentOccupancy$Params } from '../fn/occupancy/get-station-current-occupancy';
import { getStationOccupancy } from '../fn/occupancy/get-station-occupancy';
import { GetStationOccupancy$Params } from '../fn/occupancy/get-station-occupancy';
import { LiveOccupancy } from '../models/live-occupancy';
import { OccupancyRatesPerDay } from '../models/occupancy-rates-per-day';

@Injectable({ providedIn: 'root' })
export class OccupancyService extends BaseService {
  constructor(config: ShivaWebPublicConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getStationOccupancy()` */
  static readonly GetStationOccupancyPath = '/stations/{uid}/occupancy';

  /**
   * Occupancy of a station per hour for each day of the week.
   *
   * return the current week occupancies statistics, or those of the provided week number
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getStationOccupancy()` instead.
   *
   * This method doesn't expect any request body.
   */
  getStationOccupancy$Response(params: GetStationOccupancy$Params, context?: HttpContext): Observable<StrictHttpResponse<OccupancyRatesPerDay>> {
    return getStationOccupancy(this.http, this.rootUrl, params, context);
  }

  /**
   * Occupancy of a station per hour for each day of the week.
   *
   * return the current week occupancies statistics, or those of the provided week number
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getStationOccupancy$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getStationOccupancy(params: GetStationOccupancy$Params, context?: HttpContext): Observable<OccupancyRatesPerDay> {
    return this.getStationOccupancy$Response(params, context).pipe(
      map((r: StrictHttpResponse<OccupancyRatesPerDay>): OccupancyRatesPerDay => r.body)
    );
  }

  /** Path part for operation `getStationCurrentOccupancy()` */
  static readonly GetStationCurrentOccupancyPath = '/stations/{uid}/occupancy/current';

  /**
   * Live occupancy of a station for the current day within an hour window.
   *
   * return the raw number of transactions on the station for the given hour window
   * of the current day (e.g. startHour=15, endHour=16).
   * Meant to be compared by the client against the historical averages returned by /stations/{uid}/occupancy.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getStationCurrentOccupancy()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  getStationCurrentOccupancy$Response(params: GetStationCurrentOccupancy$Params, context?: HttpContext): Observable<StrictHttpResponse<LiveOccupancy>> {
    return getStationCurrentOccupancy(this.http, this.rootUrl, params, context);
  }

  /**
   * Live occupancy of a station for the current day within an hour window.
   *
   * return the raw number of transactions on the station for the given hour window
   * of the current day (e.g. startHour=15, endHour=16).
   * Meant to be compared by the client against the historical averages returned by /stations/{uid}/occupancy.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getStationCurrentOccupancy$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  getStationCurrentOccupancy(params: GetStationCurrentOccupancy$Params, context?: HttpContext): Observable<LiveOccupancy> {
    return this.getStationCurrentOccupancy$Response(params, context).pipe(
      map((r: StrictHttpResponse<LiveOccupancy>): LiveOccupancy => r.body)
    );
  }

}
